import React from "react";
import "./style.scss";
import { NavLink } from "react-router-dom";
import { Button, ButtonProps } from "../button";

type TransitionButtonProps = {
  to: string;
} & ButtonProps;

export const TransitionButton = (props: TransitionButtonProps) => {
  const { to, label, type, fillType, buttonSize } = props;
  return (
    <NavLink to={to} className="buttonLinker">
      <Button
        label={label}
        type={type}
        fillType={fillType}
        buttonSize={buttonSize}
      />
    </NavLink>
  );
};
